import { Subtract } from 'ui/icons/action/Subtract';
import { Checkmark } from 'ui/icons/action/Checkmark';
import { IconWrapper, StyledCheckbox, CheckboxContainer, Label, Description } from './Styled';
import { CheckboxProps } from './types';
import { FlexSpacer } from 'ui/flexSpacer';

export const Checkbox = ({
  DescriptionText,
  isDisabled = false,
  id,
  name,
  setChecked,
  status,
  label,
  forceMountIcon,
  ...props
}: CheckboxProps) => {
  return (
    <CheckboxContainer {...props}>
      <StyledCheckbox
        data-test="checkbox"
        disabled={isDisabled}
        name={name}
        checked={status}
        onCheckedChange={setChecked}
        id={id}
      >
        <IconWrapper forceMount={forceMountIcon} data-test="checkbox-icon-wrapper">
          {status === 'indeterminate' && (
            <Subtract
              className="indeterminate"
              data-test="indeterminate-icon"
              color="white"
              width={13}
            />
          )}
          {status === true && <Checkmark data-test="check-icon" color="white" height={8} />}
        </IconWrapper>
      </StyledCheckbox>
      <FlexSpacer alignItems="stretch" flexDirection="column" gap="0">
        <Label htmlFor={id}>{label}</Label>
        {DescriptionText && <Description>{DescriptionText}</Description>}
      </FlexSpacer>
    </CheckboxContainer>
  );
};
